import * as React from "react"
import type { SVGProps } from "react"
const SvgLandingPage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 20.29q-.82 0-1.41-.6A2 2 0 0 1 3 18.3v-12q0-.82.59-1.42A2 2 0 0 1 5 4.3h14q.83 0 1.41.58.6.6.59 1.42v12q0 .83-.59 1.4a2 2 0 0 1-1.41.6zm0-2h8.5v-3.5H5zm10.5 0H19v-9h-3.5zM5 12.79h8.5v-3.5H5z" />
  </svg>
)
export default SvgLandingPage
